import { Asset, AssetType, FolderContent } from '@/api/generatedApi';
import { ActionIconButton } from '@/components/IconButton';
import { AssetSelectionModal } from '@/components/modals/AssetSelectionModal';
import { Add } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { useState } from 'react';

const getRowClassName = (parameters: { row: FolderContent }) => {
  if (parameters.row.contentType === 'asset') {
    const asset = parameters.row as Asset;
    return asset.type === AssetType.Document ? 'disabled-row' : '';
  }
  return '';
};

export const SelectAsset = ({ onAssetSelect }: { onAssetSelect: (asset: Asset) => void }) => {
  const [isAssetSelectionModalOpen, setIsAssetSelectionModalOpen] = useState(false);

  const handleButtonClick = () => {
    setIsAssetSelectionModalOpen(true);
  };

  const handleAssetSelect = (selectedAsset: Asset) => {
    if (selectedAsset.type !== AssetType.Document) {
      onAssetSelect(selectedAsset);
      setIsAssetSelectionModalOpen(false);
    }
  };

  return (
    <Box margin='0 0 0 6px'>
      <Tooltip title='Select asset'>
        <ActionIconButton onClick={handleButtonClick} enableShadow>
          <Add color='action' sx={{ fontSize: '18px' }} />
        </ActionIconButton>
      </Tooltip>
      <AssetSelectionModal
        open={isAssetSelectionModalOpen}
        onClose={() => setIsAssetSelectionModalOpen(false)}
        onAssetSelect={handleAssetSelect}
        getRowClassName={getRowClassName}
        title='Select Asset'
        description='Choose an asset to find suitable substitutes. Documents are not available for selection.'
      />
    </Box>
  );
};
